import { useQuery } from "@tanstack/react-query";
import { tenantQueries } from "@surgia/api/src/queryStore/shared/tenant";

interface UseGetTenantProductsParams {
  tenantId: string | number;
  search: string;
  filters: {
    id?: string;
    price_from?: string;
    price_to?: string;
    category?: string;
    brandName?: string;
    category_name?: string;
  };
  currentPage: number;
  tenantResponse?: any;
  size: number;
  sort?: string;
  currencyCode?: string; // Add this
}

export const useGetTenantProducts = ({
  tenantId,
  search,
  filters,
  currentPage,
  tenantResponse,
  size,
  sort,
  currencyCode, // Add this
}: UseGetTenantProductsParams) => {
  return useQuery({
    ...tenantQueries.queries.tenantProducts({
      tenant_id: +tenantId!,
      component_id: import.meta.env.VITE_PUBLIC_COMPONENT_ID,
      name: search,
      id: filters?.id ? filters.id : undefined,
      price_from: filters?.price_from ? filters.price_from : undefined,
      price_to: filters?.price_to ? filters.price_to : undefined,
      categories: filters?.category ? filters.category : undefined,
      brand_name: filters?.brandName ? filters.brandName : undefined,
      page: currentPage,
      size: size,
      currently_assigned: true,
      sort: sort,
      category_name: filters?.category_name ? filters.category_name : undefined,
      currency_code: currencyCode, // Add this
    }),
    select: (data) => {
      return {
        total: data.total,
        data: data.data.map((tenant: any) => ({
          ...tenant,
          id: tenant.product_id,
          sku: {
            tenantProductSKU: tenant.tenant_product_sku,
            surgiaProductSKU: tenant.catalog_info.sku,
          },
          name: {
            surgiaProductImage:
              tenant.catalog_info?.product_images[0]?.image_path,
            surgiaProductName: tenant.catalog_info.name,
            tenantProductName: tenant.tenant_product_name,
          },
          variation: tenant.catalog_info.variants_count,
          city: tenant.city?.name || "Unknown",
          category: {
            surgiaFirstCategory:
              tenant?.catalog_info?.product_categories?.[0]?.category?.name,
            surgiaSecondCategory:
              tenant?.catalog_info?.product_categories?.[0]?.category
                ?.parent_category?.name,
            surgiaThirdCategory:
              tenant?.catalog_info?.product_categories?.[0]?.category
                ?.parent_category?.parent_category?.name,
          },
          brand: {
            surgiaBrandName:
              tenant.catalog_info.product_brands?.[0]?.brand_name,
            surgiaBrandImage:
              tenant.catalog_info.product_brands?.[0]?.brand_url,
          },
          price: {
            price: tenant.tenant_product_prices?.[0]?.price,
            currency: tenant.tenant_product_prices?.[0]?.currency?.code,
          },
          status: tenant.customer_view,
          tenant_name: tenantResponse?.data[0].name,
          tenant_id: tenantResponse?.data[0].id,
        })),
      };
    },
    // placeholderData: keepPreviousData,
  });
};
